import angular from 'angular';

angular.module('cloudX').directive('validateNotNull', [
  function() {
    return {
      restrict: 'A',
      require: ['?ngModel', '^?bindErrors'],
      link: function(scope, element, attributes, ctrls) {
        var ngModel = ctrls[0];
        var bindErrors = ctrls[1];
        if (!ngModel) return;

        ngModel.$validators.notNull = function(modelValue) {
          if (attributes.validateNotNull === '' || !scope.$eval(attributes.validateNotNull))
            return true;
          if (typeof modelValue === 'undefined') return true;
          return modelValue !== null;
        };
        if (bindErrors) {
          bindErrors.addError('notNull', 3017);
          //ngModel.$viewChangeListeners.push(function () {
          //    bindErrors.refreshErrors(ngModel.$error);
          //});
          //scope.$on('$destroy', function () {
          //    bindErrors.refreshErrors();
          //});
        }
        attributes.$observe('validateNotNull', function() {
          ngModel.$validate();
        });
      },
    };
  },
]);
